var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeco4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.357422 25V60.35H34.591C34.591 40.8368 19.2544 25 0.357422 25Z",
    fill: "#B1C5F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M34.591 -10V25C15.6941 25 0.357422 9.32 0.357422 -10H34.591Z",
    fill: "#3267E3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M34.591 25V60.35C53.4879 60.35 68.8246 44.5132 68.8246 25H34.591Z",
    fill: "#3267E3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M34.591 -10C53.4879 -10 68.8246 5.68 68.8246 25H34.591V-10Z",
    fill: "#B1C5F6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeco4);
export default __webpack_public_path__ + "static/media/deco4.372b08389bd9673ba13907a425da8d3a.svg";
export { ForwardRef as ReactComponent };